const useNodeColor = (
  palettes,
  colorToggle,
  showContributions
) => {
  const getStateEnabled = (quarter, colorToggle, palette) => {
    return {
      pale: colorToggle.zeroTo25 ? palette.pale : '#CCCCCC',
      light: colorToggle.twentySixTo50 ? palette.light : '#CCCCCC',
      medium: colorToggle.fiftyOneTo75 ? palette.medium : '#CCCCCC',
      dark: colorToggle.seventySixTo100 ? palette.dark : '#CCCCCC',
    }[quarter];
  };
  const getTextStateEnabled = (quarter, colorToggle, palette) => {
    return {
      pale: colorToggle.zeroTo25 ? palette.light : '#CCCCCC',
      light: colorToggle.twentySixTo50 ? palette.light : '#CCCCCC',
      medium: colorToggle.fiftyOneTo75 ? palette.light : '#CCCCCC',
      dark: colorToggle.seventySixTo100 ? palette.light : '#CCCCCC',
    }[quarter];
  };

  const getColors = (node, minContribution, maxContribution) => {
    if (!palettes || !palettes.rPalette || !palettes.cPalette) return 'white';

    if (node.isPassive) return palettes.pPalette.medium;
    const breakVal = (maxContribution - minContribution) / 4;
    let fill = 'black';
    const c = node.contribution;

    if (node.type === 'col') {
      fill = (!showContributions)
        ? palettes.cPalette.light
        : (c >= minContribution && c <= minContribution + breakVal)
          ? getStateEnabled('pale', colorToggle, palettes.cPalette)
          : (c > (minContribution + breakVal) && c <= minContribution + (breakVal * 2))
            ? getStateEnabled('light', colorToggle, palettes.cPalette)
            : (c > (minContribution + (breakVal * 2)) && c <= minContribution + (breakVal * 3))
              ? getStateEnabled('medium', colorToggle, palettes.cPalette)
              : getStateEnabled('dark', colorToggle, palettes.cPalette);
    } else { // node.type === 'row'
      fill = (!showContributions)
        ? palettes.rPalette.light
        : (c >= minContribution && c <= minContribution + breakVal)
          ? getStateEnabled('pale', colorToggle, palettes.rPalette)
          : (c > (minContribution + breakVal) && c <= minContribution + (breakVal * 2))
            ? getStateEnabled('light', colorToggle, palettes.rPalette)
            : (c > (minContribution + (breakVal * 2)) && c <= minContribution + (breakVal * 3))
              ? getStateEnabled('medium', colorToggle, palettes.rPalette)
              : getStateEnabled('dark', colorToggle, palettes.rPalette);
    }

    return fill;
  };

  const getTextFill = (node, minContribution, maxContribution) => {
    if (!palettes || !palettes.rPalette || !palettes.cPalette) return 'white';

    if (node.isPassive) return palettes.pPalette.light;
    const breakVal = (maxContribution - minContribution) / 4;
    let fill = 'black';
    const c = node.contribution;

    if (node.type === 'col') {
      fill = (!showContributions)
        ? palettes.cPalette.light
        : (c >= minContribution && c <= minContribution + breakVal)
          ? getTextStateEnabled('pale', colorToggle, palettes.cPalette)
          : (c > (minContribution + breakVal) && c <= minContribution + (breakVal * 2))
            ? getTextStateEnabled('light', colorToggle, palettes.cPalette)
            : (c > (minContribution + (breakVal * 2)) && c <= minContribution + (breakVal * 3))
              ? getTextStateEnabled('medium', colorToggle, palettes.cPalette)
              : getTextStateEnabled('dark', colorToggle, palettes.cPalette);
    } else { // node.type === 'row'
      fill = (!showContributions)
        ? palettes.rPalette.light
        : (c >= minContribution && c <= minContribution + breakVal)
          ? getTextStateEnabled('pale', colorToggle, palettes.rPalette)
          : (c > (minContribution + breakVal) && c <= minContribution + (breakVal * 2))
            ? getTextStateEnabled('light', colorToggle, palettes.rPalette)
            : (c > (minContribution + (breakVal * 2)) && c <= minContribution + (breakVal * 3))
              ? getTextStateEnabled('medium', colorToggle, palettes.rPalette)
              : getTextStateEnabled('dark', colorToggle, palettes.rPalette);
    }

    return fill;
  }

  const getStrokeAttr = (node, minContribution, maxContribution) => {
    let clr = {
      stroke: 'black',
      strokeWidth: 3,
    };

    const getStrokeClr = quarter => quarter ? 'black' : '#999999';

    if (node.isPassive) {
      clr = {
        stroke: palettes.pPalette.light,
        strokeWidth: 3,
      };
    } else {
      const breakVal = (maxContribution - minContribution) / 4;
      const c = node.contribution;
      clr.strokeWidth = 1;
      if (!showContributions) clr.stroke = 'black';
      else {
        clr.stroke = (c >= minContribution && c <= minContribution + breakVal)
          ? getStrokeClr(colorToggle.zeroTo25)
          : (c > (minContribution + breakVal) && c <= minContribution + (breakVal * 2))
            ? getStrokeClr(colorToggle.twentySixTo50)
            : (c > (minContribution + (breakVal * 2)) && c <= minContribution + (breakVal * 3))
              ? getStrokeClr(colorToggle.fiftyOneTo75)
              : getStrokeClr(colorToggle.seventySixTo100);
      }
    }

    return clr;
  };

  return [getColors, getStrokeAttr, getTextFill];
};

export default useNodeColor;
